import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getCategorias,
  deleteCategoria,
  changeStatusCategoria,
  updateCategoria,
} from "../../../../api/categoria";
import { Button, Tooltip, Switch, FormControlLabel, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { getNonEmpty } from "../../../../utils/helpers";

function getData(categorias) {
  let data = [];
  for (let i = 0; i < categorias.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(categorias[i].titulo);
    elem.orden = categorias[i].orden;
    elem.id = categorias[i]._id;
    elem.active = categorias[i].active;
    elem.showInActualidad = categorias[i].showInActualidad !== false;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.orden - b.orden);
  return data;
}

const initialFilters = {
  active: false,
};

export default function CategoriasPage() {
  const [data, setData] = useState([]);
  const [categoriaId, setCategoriaId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem('categoriasPageFilters');
    return savedFilters ? JSON.parse(savedFilters) : initialFilters;
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem('categoriasPage_searchText');
    return saved || '';
  });
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);
  function buttonFormatter(cell) {
    const elem = filteredData.find((item) => item._id === cell);
    const categoriaMongoId = elem?._id || cell;
    const handleSubtract = () => {
      setFilteredData((prevFilteredData) => {
        const currentCategoria = prevFilteredData.find(
          (cate) => cate._id === cell
        );
        if (!currentCategoria || currentCategoria.orden === 0)
          return prevFilteredData;

        const newOrder = currentCategoria.orden - 1;
        const categoriaToSwap = prevFilteredData.find(
          (cate) => cate.orden === newOrder
        );

        return prevFilteredData.map((categoria) => {
          if (categoria._id === cell) {
            return { ...categoria, orden: newOrder };
          }
          if (categoriaToSwap && categoria._id === categoriaToSwap._id) {
            return { ...categoria, orden: currentCategoria.orden };
          }
          return categoria;
        });
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setFilteredData((prevFilteredData) => {
        const currentCategoria = prevFilteredData.find(
          (cate) => cate._id === cell
        );
        if (
          !currentCategoria ||
          currentCategoria.orden === prevFilteredData.length - 1
        )
          return prevFilteredData;

        const newOrder = currentCategoria.orden + 1;
        const categoriaToSwap = prevFilteredData.find(
          (cate) => cate.orden === newOrder
        );

        return prevFilteredData.map((categoria) => {
          if (categoria._id === cell) {
            return { ...categoria, orden: newOrder };
          }
          if (categoriaToSwap && categoria._id === categoriaToSwap._id) {
            return { ...categoria, orden: currentCategoria.orden };
          }
          return categoria;
        });
      });
      setRefreshOrder(true);
    };

    return (
      <>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={"Up"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={handleSubtract}
                disabled={elem?.orden === 0}
              >
                <KeyboardArrowUp />
              </Button>
            </Tooltip>
            <Tooltip title={"Down"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={handleAdd}
                disabled={elem?.orden === data.length - 1}
              >
                <KeyboardArrowDown />
              </Button>
            </Tooltip>
            <Tooltip title="Edit">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  // Guardar filtros actuales antes de navegar
                  localStorage.setItem('categoriasPageFilters', JSON.stringify(filterOptions));
                  history.push("/edit-categoria/" + cell);
                }}
              >
                <EditIcon />
              </Button>
            </Tooltip>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCategoriaId(elem || { _id: cell, active: false });
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip
              title={
                elem?.showInActualidad
                  ? "Ocultar en Actualidad"
                  : "Mostrar en Actualidad"
              }
            >
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  if (!categoriaMongoId) {
                    alertError({
                      customMessage: "No se encontró el ID de la categoría.",
                    });
                    return;
                  }
                  updateCategoria(categoriaMongoId, {
                    showInActualidad: !elem?.showInActualidad,
                  })
                    .then((res) => {
                      if (res.status === 200) {
                        alertSuccess({
                          title: "Guardado",
                          customMessage: !elem?.showInActualidad
                            ? "La categoría se mostrará en Actualidad."
                            : "La categoría se ha ocultado de Actualidad.",
                        });
                        setRefresh(true);
                      }
                    })
                    .catch((error) => {
                      alertError({
                        error,
                        customMessage:
                          "No se pudo actualizar la visibilidad en Actualidad.",
                      });
                    });
                }}
              >
                {elem?.showInActualidad ? (
                  <VisibilityOffIcon />
                ) : (
                  <VisibilityIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCategoriaId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "titulo", text: "Titulo", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        getCategorias()
          .then((res) => {
            if (res.status === 200) {
              setData(res.data);
              // Aplicar filtros guardados si existen
              const savedFilters = localStorage.getItem('categoriasPageFilters');
              if (savedFilters) {
                const savedFilterOptions = JSON.parse(savedFilters);
                setFilterOptions(savedFilterOptions);
                // Aplicar filtros automáticamente
                const filtered = res.data.filter((item) => {
                  let filter = true;
                  if (savedFilterOptions.active) filter = filter && item.active;
                  if (filter) return item;
                  return false;
                });
                setFilteredData(filtered);
              } else {
                setFilteredData(res.data);
              }
              setRefresh(false);
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get categorias.",
            });
          });
      } catch (error) {}
    };

    fetchData();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    // Guardar filtros en localStorage
    localStorage.setItem('categoriasPageFilters', JSON.stringify(filterOptions));
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText('');
    localStorage.removeItem('categoriasPageFilters');
    localStorage.removeItem('categoriasPage_searchText');
    localStorage.removeItem('categoriasPage_currentPage');
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Primera fila: Campo de búsqueda */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('categoriasPage_searchText', value);
                } else {
                  localStorage.removeItem('categoriasPage_searchText');
                }
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Categorías">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-categoria")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refreshOrder && (
            <Table 
              data={getData(filteredData)} 
              columns={columns} 
              pageKey="categoriasPage"
              searchText={searchText}
              onSearchChange={(value) => {
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('categoriasPage_searchText', value);
                } else {
                  localStorage.removeItem('categoriasPage_searchText');
                }
              }}
            />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              categoriaId?.active ? "disable" : "enable"
            } this user type?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              const statusTargetId = categoriaId?._id || categoriaId?.id;
              if (!statusTargetId) {
                alertError({
                  customMessage: "No se encontró el ID de la categoría.",
                });
                return;
              }
              changeStatusCategoria(
                statusTargetId,
                !categoriaId?.active
              )
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        categoriaId?.active ? "Disabled!" : "Enabled!"
                      }`,
                      customMessage: `User type ${
                        categoriaId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      categoriaId?.active ? "disable" : "enable"
                    } user type.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user type?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCategoria(categoriaId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Categoria removed successfully.",
                    });
                    setRefresh(true);
                    setRefreshOrder(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove categoria.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
